class HtmlFormater {

  static parseMarkDownImages(htmlString: string): string {
    let node = document.createElement('div');
    node.innerHTML = htmlString;

    this.parseMarkDownImagesLinks(node);
    this.parseMarkDownImagesHeight(node);
    this.parseMarkDownRemoveCaptions(node);
    return node.outerHTML;
  }

  static parseMarkDownImagesHeight(node: HTMLDivElement): void {
    let images = node.getElementsByTagName('img');

    for (var i = 0; i < images.length; i++) {

      images[i].setAttribute('height', 'auto');
    }
  }

  static parseMarkDownImagesLinks(node: HTMLDivElement): void {
    let links = node.getElementsByTagName('a');

    for (var i = 0; i < links.length; i++) {

      if (links[i].children && links[i].children.length && links[i].children[0].tagName === 'IMG') {
        links[i].removeAttribute('href');
      }
    }
  }

  static parseMarkDownRemoveCaptions(node: HTMLDivElement): void {
    let captions = node.getElementsByClassName('attachment__caption');

    for (var i = 0; i < captions.length; i++) {
      if (captions[i]) {
        captions[i].innerHTML = '';
      }
    }
  }

}

export default HtmlFormater;


// WEBPACK FOOTER //
// ./src/utils/htmlFormaterUtil.ts